export const TEXTS = {
	CTA: 'Crear nuevo link',
	PAGES: {
		HOME: {
			BREADCRUMB_TITLE: 'Payment Links 3.0',
			BREADCRUMB_SUBTITLE: 'Pagos recibidos',
		},
		ALL: {
			BREADCRUMB_TITLE: 'Payment Links 3.0',
			BREADCRUMB_SUBTITLE: 'Pagos recibidos',
		},
		LINKS: {
			BREADCRUMB_TITLE: 'Payment Links 3.0',
			BREADCRUMB_SUBTITLE: 'Mis enlaces',
		},
	},
};
